/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailStone_item = {|
  +attributes: ?{|
    +stone: ?$ReadOnlyArray<?{| |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailStone_item",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailAttributeLink_item",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "stone",
          "args": [
            {
              "kind": "Literal",
              "name": "attributeType",
              "value": "stone",
              "type": "MaterialAttributeType"
            }
          ],
          "concreteType": "AttributeValue",
          "name": "material",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDetailAttributeLink_attributes",
              "args": null
            }
          ],
          "storageKey": "material{\"attributeType\":\"stone\"}"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
